var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookLightDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2663_61305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.0375C12 2.703 9.31347 0 5.99997 0C2.68497 0.00075 -0.00152588 2.703 -0.00152588 6.03825C-0.00152588 9.051 2.19297 11.5485 5.06097 12.0015V7.78275H3.53847V6.03825H5.06247V4.707C5.06247 3.19425 5.95872 2.35875 7.32897 2.35875C7.98597 2.35875 8.67222 2.4765 8.67222 2.4765V3.9615H7.91547C7.17072 3.9615 6.93822 4.42725 6.93822 4.905V6.0375H8.60172L8.33622 7.782H6.93747V12.0007C9.80547 11.5477 12 9.05025 12 6.0375Z",
    fill: "#F0ECFE",
    fillOpacity: 0.7333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2663_61305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLightDark);
export default __webpack_public_path__ + "static/media/facebook_light_dark.755f6252fe49024ffd2fd294d0ce258e.svg";
export { ForwardRef as ReactComponent };